import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-Books',
  templateUrl: './Books.component.html',
  styleUrls: ['./Books.component.scss']
})
export class BooksComponent implements OnInit {
title = 'Books';
  constructor() { }

  ngOnInit() {
  }

}
